import { isValidUrl } from "../util";
import FileThumbnail from "./FileThumbnail";


const TransformValue = ({value}) => {

    if (typeof value === "string") {
        const trimmedValue = value.trim();

        if (trimmedValue.startsWith("[") || trimmedValue.startsWith("{")) {
            try{
                value = JSON.parse(value)
            }catch{}
        }
    }

    if(Array.isArray(value))
    return (
        <>
             {value?.map((ref, idx) => {
                 return (
                    isValidUrl(ref) ? <FileThumbnail key={idx} name={ref} /> : <span key={idx}>{ref}</span>
                 )
             })}
        </>
    )

    if(({}).constructor === value?.constructor){
        return (
            <span dangerouslySetInnerHTML={{__html: value?.name}}></span>
        )
    }

    return (
        <span dangerouslySetInnerHTML={{__html: value}}></span>
    )
}

export default TransformValue
